<template>
  <div class="disclaimer-modal-content">
    <h2>Disclaimer</h2>
    <p v-html="formattedDisclaimer"></p>
    <button class="button button-grey" :style="buttonStyle" type="button" @click="$emit('close')">Close</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      customization: (state) => state.common.customization,
      dealerDisclaimer: (state) => state.common.dealerDisclaimer
    }),
    buttonStyle () {
      return {
        color: this.customization.fontColor,
        'background-color': this.customization.mainColor
      }
    },
    formattedDisclaimer () {
      return (this.dealerDisclaimer || '').replace(/\n/g, '<br />')
    }
  }
}
</script>

<style scoped>
.disclaimer-modal-content{
    padding: 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
}

.disclaimer-modal-content h2{
    color: #3172DF;
    font-weight: 600;
}

.disclaimer-modal-content p{
    text-align: left;
}

.disclaimer-modal-content .button{
    margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// price-disclaimer.vue?0a2d4f09